import { LoadingButton } from "@mui/lab";
import { Alert, Button, Grid, MenuItem, TextField } from "@mui/material";
import AutoCompleteList from "components/AutoCompleteList";
import AutoCompleteListFormik from "components/AutoCompleteListFormik";
import { useFormik } from "formik";
import ProductVariantsInDialog from "pages/products/menu/ProductVariantsInDialog";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import {
  getLocationsThunk,
  locationSelector,
} from "store/reducers/inventory/locationSlice";
import { adminStockTransactionThunk } from "store/reducers/inventory/stock/adminStockSlice";
import { locationStockTransactionThunk, resetStat } from "store/reducers/inventory/stock/locationStockSlice";
import { mainStockTransactionThunk } from "store/reducers/inventory/stock/mainStockSlice";
import {
  categorySelector,
  getCategoriesThunk,
} from "store/reducers/product/categorySlice";
import {
  getProductsThunk,
  productSelector,
} from "store/reducers/product/productSlice";
import {
  getVariantsForProductThunk,
  productVariantSelector,
} from "store/reducers/product/productVariantSlice";
import {
  getSubCategoriesThunk,
  subCategorySelector,
} from "store/reducers/product/subCategorySlice";
import * as yup from "yup";

const validation = yup.object({
  qty: yup.number().required().positive().min(1),
  product_variant: yup.number().required(),
});
const LocationStockInward = ({ fullGrid = false, mode = "main-stock" }) => {
  const formik = useFormik({
    initialValues: {
      location: null,
      qty: 10,
      product_variant: "",
    },
    validationSchema: validation,
    onSubmit: (data) => {
      console.log(data);
      const mData = { ...data, in_or_out: "in", location: data.location.id };
      dispatch(locationStockTransactionThunk({ data: mData }));
    },
    validateOnChange: false,
  });

  const [category, setCategory] = useState(null);
  const [subCategory, setSubCategory] = useState(null);
  const [product, setProduct] = useState(null);

  const categories = useSelector(categorySelector.selectAll);
  const subCategories = useSelector(subCategorySelector.selectAll).filter(
    (item) => item.category === category?.id
  );

  const products = useSelector(productSelector.selectAll).filter(
    (item) =>
      item.category === category?.id && item.sub_category === subCategory?.id
  );

  const variants = useSelector(productVariantSelector.selectAll).filter(
    (item) => item.product === product?.id
  );
  useEffect(() => {
    dispatch(getCategoriesThunk());
  }, []);

  useEffect(() => {
    if (category) {
      setSubCategory(null);
      dispatch(getSubCategoriesThunk(category.id));
    }
  }, [category]);

  useEffect(()=>{
    dispatch(resetStat())
  },[])

  useEffect(() => {
    if (category) {
      dispatch(
        getProductsThunk({
          category: category?.id ?? "",
          subCategory: subCategory?.id ?? "",
          page_size:1000
        })
      );
    }
  }, [category, subCategory]);

  useEffect(() => {
    if (product) {
      dispatch(getVariantsForProductThunk(product.id));
    }
  }, [product]);
  const [openVariantUpdate, setOpenVariantUpdate] = React.useState(false);
  const handleVariantClose = () => {
    setOpenVariantUpdate(false);
  };
  const state = useSelector(
    (state) => state.locationStock.locationStockTransactionStatus
  );
  useEffect(() => {
    dispatch(getLocationsThunk());
  }, []);
  const locations = useSelector(locationSelector.selectAll);
  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1.5} paddingY={1}>
          <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
            <AutoCompleteListFormik
              items={locations}
              name="name"
              label="Choose location"
              formik={formik}
              formikName="location"
              required={true}
            />
          </Grid>
          <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
            <AutoCompleteList
              items={categories}
              name="name"
              label="Filter categories"
              setValue={setCategory}
              value={category}
            />
          </Grid>

          <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
            <AutoCompleteList
              items={subCategories}
              name="name"
              label="Filter subcategories"
              setValue={setSubCategory}
              value={subCategory}
            />
          </Grid>
          <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
            <AutoCompleteList
              items={products}
              name="name"
              label="Select product"
              setValue={setProduct}
              value={product}
            />
          </Grid>
          <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
            <TextField
              label="Select price variant"
              variant="outlined"
              name="product_variant"
              select
              fullWidth
              value={formik.values.product_variant}
              onChange={formik.handleChange("product_variant")}
              error={Boolean(formik.errors.product_variant)}
              helperText={formik.errors.product_variant}
              autoComplete="new-password"
            >
              {variants.map((variant) => (
                <MenuItem value={variant.id}>₹{variant.price}</MenuItem>
              ))}
            </TextField>
            {product && (
              <Button
                size="small"
                sx={{ mt: 1 }}
                onClick={() => {
                  setOpenVariantUpdate(true);
                }}
              >
                Add new
              </Button>
            )}
          </Grid>
          <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
            <TextField
              label="Qty"
              variant="outlined"
              name="qty"
              fullWidth
              value={formik.values.qty}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.qty)}
              helperText={formik.errors.qty}
              autoComplete="new-password"
            />
          </Grid>
        </Grid>

        {state?.error === "post" && (
          <Alert sx={{ my: 1 }} severity="error">
            Error occurred , {this.state?.errorMessage}
          </Alert>
        )}

        {state?.success === "post" && (
          <Alert sx={{ my: 1 }} severity="success">
            Success
          </Alert>
        )}
        <LoadingButton
          loading={state?.loading === "post"}
          variant="contained"
          type="submit"
          sx={{ paddingX: 10, marginTop: 1 }}
        >
          Add stock
        </LoadingButton>
      </form>
      {product && (
        <ProductVariantsInDialog
          open={openVariantUpdate}
          handleClose={handleVariantClose}
          product={product}
        />
      )}
    </>
  );
};

export default LocationStockInward;
